/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from 'react';
import {usePrimeCache} from "../../../../Hooks/ServiceHooks";
import {service as SpeciesTypeService} from "../../../../Services/SpeciesTypeService";
import {service as SpeciesNativityService} from "../../../../Services/SpeciesNativityService";
import {service as SpeciesInvasivityService} from "../../../../Services/SpeciesInvasivityService";
import {Col, FormControl, Row} from "react-bootstrap";
import {useUpdateTableFilters} from "../../../../Hooks/TableHooks";
import {LastModifiedSpeciesLabel} from "../Common/SpeciesTable/LastModifiedSpeciesLabel";

export const GlobalSpeciesTableFilter = (props) => {
    const {
        Data,
        UpdateFilters: updateFilters = null,
        OnEditClick,
        filterValues,
        setFilterValue
    } = props;

    usePrimeCache([
        SpeciesTypeService,
        SpeciesNativityService,
        SpeciesInvasivityService,
    ]);

    const types = SpeciesTypeService.CachedValues()?.result ?? [];

    const {
        speciesTypeId = null,
        textFilter = ''
    } = filterValues;

    const textFilterUppercase = textFilter?.toUpperCase?.();
    
    const filters = [
        {
            code: 'textFilter',
            isSet: textFilterUppercase !== "",
            logic:  x => x?.commonName?.toUpperCase?.().includes(textFilterUppercase) ||
                         x?.latinName?.toUpperCase?.().includes(textFilterUppercase) ||
                         SpeciesTypeService.CachedTitleById(x?.speciesTypeId)?.toUpperCase?.().includes(textFilterUppercase) ||
                         SpeciesNativityService.CachedTitleById(x?.speciesNativityId)?.toUpperCase?.().includes(textFilterUppercase) ||
                         SpeciesInvasivityService.CachedTitleById(x?.speciesInvasivityId)?.toUpperCase?.().includes(textFilterUppercase)
        },
        {
            code: "speciesTypeId",
            isSet: !!speciesTypeId,
            logic: x => Number(x?.speciesTypeId) === Number(speciesTypeId)
        }
    ];

    useUpdateTableFilters(filters, updateFilters, [textFilter, speciesTypeId]);

    return <Fragment>
        <Col md={6} sm={12} xs={12}>
            <LastModifiedSpeciesLabel data={Data} onDateClick={(id) => OnEditClick(id)} />
        </Col>
        <Col md={6} sm={12} xs={12}>
            <Row className="justify-content-end">
                <Col xs={6} className="d-flex align-items-center">
                    <FormControl
                        as="select"
                        type="text"
                        value={speciesTypeId ?? ""}
                        placeholder="Growth Form"
                        onChange={event => setFilterValue('speciesTypeId', event.target.value)}
                    >
                        <option value={""}>Growth Form</option>
                        {
                            types.map(x =>
                                <option key={x.speciesTypeId} value={x.speciesTypeId}>
                                    {x.name}
                                </option>
                            )
                        }
                    </FormControl>
                </Col>
                <Col xs={6} className="d-flex align-items-center">
                    <FormControl
                        type="text"
                        value={textFilter || ""}
                        placeholder="Search Names"
                        onChange={event => setFilterValue('textFilter', event.target.value)}
                    />
                </Col>
            </Row>
            <Row/>
        </Col>
    </Fragment>;
};
